<template>
  <div class style="margin-top:15px;width:90%">
    <el-form
      :model="dynamicValidateForm"
      :rules="rules"
      ref="dynamicValidateForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item label="发布企业" prop="projectname">
        <el-input v-model="projectname" disabled placeholder="请选择代发企业">
          <el-button slot="append" @click="companyGroup">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="dynamicValidateForm.projectName"></el-input>
      </el-form-item>
      <el-form-item
        v-for="(domain, index) in dynamicValidateForm.address"
        label="工程地址"
        label-width="100px"
        :key="domain.key"
        id="addproject"
        prop="address"
      >
        <el-input
          placeholder="请输入工程地址"
          v-model="domain.address"
          class="input-with-select"
        >
          <el-button
            slot="append"
            v-if="dynamicValidateForm.address.length>1"
            type="danger"
            @click="deleteaddress(index)"
          >删除</el-button>
        </el-input>
        <div class="form_layout_items" style="margin-left: -100px;margin-top:15px;float:left;">
          <el-form-item label="门牌号" prop="houseNum1">
            <el-input
              v-model="domain.houseNum"
              placeholder="例：16号楼2单元5层501室"
              style="min-width:170px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contacts1">
            <el-input v-model="domain.contacts" placeholder="现场联系人" style="min-width:170px;"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone1">
            <el-input
              v-model="domain.contactPhone"
              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
              placeholder="现场联系人电话"
              style="min-width:170px;"
            ></el-input>
          </el-form-item>
        </div>
      </el-form-item>
      <div style="text-align:center;color:#2196F3;">
        <span @click="address" style="cursor: pointer;">添加多个地址</span>
      </div>
      <hr>

      <div class="form_layout_items">
        <el-form-item label="开工时间" prop="startTime">
          <el-date-picker
            v-model="dynamicValidateForm.startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择日期"
            :picker-options="pickerOptions0"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="工作时长" prop="duration" label-width="120" style="width:330px;">
          <el-input
            style="width:200px;"
            v-model="dynamicValidateForm.duration"
            onkeyup="value=value.replace(/^[0-9]+(.[0-9]{2})+/g,'')"
            placeholder="请输入数字或小数"
          ></el-input>天
        </el-form-item>
        <el-form-item label>
          <el-checkbox v-model="dynamicValidateForm.isOvertime">需要加班</el-checkbox>
        </el-form-item>
      </div>
      <div class="form_layout_items">
        <el-form-item label="需求工种及人数" label-width="140px" prop="needNum"></el-form-item>
        <div
          v-for="(domain, index) in dynamicValidateForm.workTypes"
          :key="domain.index"
          :prop="'domain.' + index + '.value'"
          class="form_layout_items"
        >
          <el-form-item :label="domain.workTypeName">
            <el-input
              v-model.number="domain.needNum"
              class="gzstyle"
              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
              placeholder="请输入数量"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <div class="form_layout_items">
        <el-form-item label="需求工具" prop="needTools">
          <el-checkbox-group v-model="dynamicValidateForm.needTools">
            <div
              v-for="(domain,index) in needTools"
              :key="index"
              style="float :left;margin-right:10px;"
            >
              <el-checkbox :label="domain.name" name="needTools"></el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label label-width="20px">
          <el-input v-model="dynamicValidateForm.tool" placeholder="其他工具（选填）"></el-input>
        </el-form-item>
      </div>
      <hr>
      <el-form-item label="工作内容" class="upinfo" prop="tips" style="margin-bottom:0px;">
        <span @click="addContent" style="margin-right:10px;cursor: pointer;float: left;">添加</span>
        <span @click="importBtn" style="margin-right:10px;cursor: pointer;float: left;">导入</span>
        <span
          @click="contentList"
          style="margin-right:10px;cursor: pointer;float: left;"
          v-if="handleSuccessstate == true"
        >详细工作内容</span>
      </el-form-item>
      <editContent ref="editContent" @setContent="setContent"></editContent>
      <el-form-item v-if="dynamicValidateForm.domains" classes="111">
        <div
          v-for="(domain,index) in dynamicValidateForm.domains"
          :key="index"
          style="color:#606266;font-size:16px;cursor:pointer;"
        >
          <el-col :span="18">
            <span class="textOverflow" @click="editContent(domain)">{{index+1}} 、{{domain.tips}}</span>
          </el-col>
          <el-col :span="2">
            <i class="el-icon-picture">{{domain.imgCount}}</i>
          </el-col>
          <el-col :span="2">
            <i class="el-icon-video-camera">{{domain.voiceCount}}</i>
          </el-col>
          <el-col :span="2">
            <i class="el-icon-close" @click="deletetask(index)"></i>
          </el-col>
        </div>
      </el-form-item>
      <el-form-item label="项目附件" class="upinfo" prop="files" style="margin-bottom:20px;">
        <el-upload
          class="upload-demo"
          ref="uploadAppendix"
          :data="uploadData"
          :action="'/files/fileUpload'|getBaseApiUrl"
          accept="image/*, .pdf, .doc, .docx, .xls, .xlsx"
        >
          <div style="float:left; width:100px;">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </div>
          <div
            class="el-upload__tip"
            style="float:left;margin-top:0px;"
          >只能上传图片、视频、PDF、Word、Excel文件，且不超过20M</div>
        </el-upload>
      </el-form-item>
      <hr>
      <el-form-item label="项目相关人" class="upinfo">
        <span @click="addProjectPeople" style="cursor: pointer;float: left;">新增</span>
      </el-form-item>
      <div style="width:100%;margin-left:20px;margin-bottom: 20px;">
        <el-tag
          v-for="tag in tags"
          :key="tag.name"
          closable
          :disable-transitions="true"
          @close="handleClose(tag)"
          :type="tag.type"
          class="tag"
        >{{tag.name}}</el-tag>
      </div>
      <el-form-item label="发布渠道" prop="name">
        <el-col :span="24" class="fbqd">
          <el-button @click="xqdt" :class="classA==false ? 'class-a' : 'class-b'">需求大厅</el-button>
        </el-col>
        <el-col :span="24" class="fbqd">
          <el-button
            @click="workerGroup"
            :class="workerGrouptags.length==0 ? 'class-a' : 'class-b'"
          >选择群组</el-button>
          <el-tag
            v-for="tag in workerGrouptags"
            :key="tag.id"
            :disable-transitions="true"
            @click="workerGroupClose(tag)"
            :type="tag.type"
            style="margin-left:15px;"
          >{{tag.groupName}}</el-tag>
        </el-col>
        <el-col :span="24" class="fbqd">
          <el-button @click="workerBtn" :class="ownWorker.length==0 ? 'class-a' : 'class-b'">选择师傅</el-button>
          <div style="margin-left:140px;">
            <div
              v-for="tag in ownWorker"
              :key="tag.name"
              :disable-transitions="true"
              :type="tag.type"
              style="width: 80px;float: left;"
            >
              <img
                :src="tag.avatar?getimgpath(tag.avatar):(tag.headimgurl?tag.headimgurl:'/img/default-avatar.png')"
                style="width:60px;border-radius:50%;"
                @click="workerClose(tag)"
              >
              <el-tag>{{tag.name}}</el-tag>
            </div>
          </div>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button @click="savebtn">保存</el-button>
        <el-button @click="ReleaseInfo">发布</el-button>
        <el-button @click="Releasecancel">取消</el-button>
      </el-form-item>
    </el-form>
    <!--详细内容-->
    <el-dialog title="工作内容详细信息" :visible.sync="createVisible">
      <el-table
        ref="multipleTable"
        :data="contentListData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column align="center" label="序号" class="part" width="60px">
          <template slot-scope="scope">
            <span>{{getSerialNumber(scope.$index)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="品名">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="品牌">
          <template slot-scope="scope">
            <span>{{scope.row.brand}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="型号">
          <template slot-scope="scope">
            <span>{{scope.row.contentType}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="型号">
          <template slot-scope="scope">
            <span>{{scope.row.contentNum}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="单位">
          <template slot-scope="scope">
            <span>{{scope.row.contentUnit}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="位置">
          <template slot-scope="scope">
            <span>{{scope.row.position}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="描述/颜色">
          <template slot-scope="scope">
            <span>{{scope.row.tips}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--师傅群组-->
    <el-dialog title="师傅群组" :visible.sync="workerGroupVisible">
      <avue-crud
        :data="workerGroupData"
        :option="tableoptionqz"
        @selection-change="workerGroupchange"
      ></avue-crud>
      <div slot="footer" class="dialog-footer">
        <el-button @click="workerGroupTrue">确定</el-button>
        <el-button @click="workerGroupVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--师傅-->
    <el-dialog title="师傅" :visible.sync="workerVisible">
      <avue-crud-table
        :data="workerData"
        :option="tableoptionwork"
        @search-change="searchChangegr"
        @selection-change="workSelectionChange"
      ></avue-crud-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="workerTrue">确定</el-button>
        <el-button @click="workerVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--项目相关人-->
    <el-dialog title="项目相关人" :visible.sync="projectManVisible">
      <avue-crud
        ref="userCrud"
        :data="comworkerData"
        :option="tableoption"
        @refresh-change="searchChange"
        @search-change="searchChange"
        @selection-change="selectionChange"
      >
        <template slot="search">
          <el-form-item label="关键字">
            <el-input v-model="search.condition"></el-input>
          </el-form-item>
        </template>
      </avue-crud>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseTrue">确定</el-button>
        <el-button @click="projectManVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--验证提示框-->
    <el-dialog title="认证提示" :visible.sync="VerificationVisible">
      <div>{{message}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="VerificationVisible = false">继续发布</el-button>
      </div>
    </el-dialog>
    <!--项目相关人-->
    <el-dialog title="项目相关人" :visible.sync="projectManVisible">
      <avue-crud :data="comworkerData" :option="tableoption" :page="page" @size-change="sizeChange" @current-change="currentChange" @search-change="searchChange" @selection-change="selectionChange">
        <template slot-scope="scope" slot="id">
          <el-radio class="radio" v-model="radio"  :label="scope.row.id"></el-radio>
        </template>
      </avue-crud>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseTrue">确定</el-button>
        <el-button @click="projectManVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--企业查询-->
    <companylist ref="childcompany" @refresh="refresh"></companylist>

    <!--导入工作内容-->
    <el-dialog title="导入" width="30%" @close="close" :visible.sync="uploadfileDialog">
      <el-upload
        class="upload-demo"
        ref="uploadContent"
        :action="urls"
        :data="uploaddata"
        accept=".xls, .xlsx"
        :on-success="handleAvatarSuccess"
        :auto-upload="false"
      >
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button
          size="small"
          style="margin-left: 10px;"
          type="success"
          @click="submitUpload"
        >上传到服务器</el-button>
        <a
          href="https://www.91worker.cn/wxstatic/images/yuanyang1.xlsx"
          download="模板文件"
          style="margin-left: 20px;"
        >下载模板</a>
        <div slot="tip" class="el-upload__tip">只能上传xls,xlsx文件</div>
      </el-upload>
    </el-dialog>
    <el-form-item label="项目相关人" class="upinfo">
      <el-tag v-for="tag in tags" :key="tag.name" closable :disable-transitions="true"
              @close="handleClose(tag)" :type="tag.type">{{tag.name}}
      </el-tag>
      <span @click="addProjectPeople" style="cursor: pointer;" :disabled = "totalStatus">新增</span>
    </el-form-item>
    <!--发布渠道-->
    <el-dialog title="发布渠道" :visible.sync="workerVisiblequdao">
      <div style="height: auto;margin-bottom: 15px;" v-if="classA == true">需求大厅</div>
      <div style="height: auto;margin-bottom: 15px;" v-if="workerGrouptags.length>0">
        群组
        <el-tag
          v-for="tag in workerGrouptags"
          :key="tag.id"
          :disable-transitions="true"
          :type="tag.type"
          style="margin-left:15px;"
        >{{tag.groupName}}</el-tag>
      </div>
      <div style="height:200px;" v-if="ownWorker.length>0">
        <span style="float:left;">师傅</span>
        <div
          v-for="tag in ownWorker"
          :key="tag.name"
          :disable-transitions="true"
          :type="tag.type"
          style="width: 80px;float: left;"
        >
          <img
            :src="tag.avatar?getimgpath(tag.avatar):(tag.headimgurl?tag.headimgurl:'/img/default-avatar.png')"
            style="width:60px;border-radius:50%;"
          >
          <el-tag>{{tag.name}}</el-tag>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quertok">确定</el-button>
        <el-button @click="workerVisiblequdao = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGroupList,
  getWorkerList,
  companyVerification,
  getOrderCode,
  getProjectContents,
  insertOrUpdate,
  putProjectContents,
  putProjectfile
} from "@/api/admin/addProject";
import {getCompanyInfo} from "@/api/admin/business"
import { getDictList } from "@/api/admin/dict";
import { getProjectInfo } from "@/api/admin/taskManagement";
import { getWorkerInfo, getdicts } from "@/api/admin/business";
import { mapGetters } from "vuex";
import { fetchList } from "@/api/admin/groups";
import { objKeySort } from "@/util/ajaxsign";
import { getImgLink, apiLink } from "@/config/env";
import { personnelget1, groupqz } from "@/const/asset/user";
import { dealElement } from "@/util/util";
import { phone } from "@/util/Format";
import editContent from "./editContent";
import companylist from './companylist.vue'

import { permissionUpd } from "@/api/admin/role";
export default {
  data() {
    return {
      //用于保存代发企业的信息
      companyInfo:{},
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() <= new Date().getTime() - 86400000;
        }
      },
      projectname : '',
      classA: false,
      workerVisiblequdao: false,
      projectId: "",
      companyState: 0,
      totalStatus: true,
      uploaddata: {
        Token: "",
        projectId: ""
      },
      searchgr: {},
      fadate: "",
      dic: {
        workTypes: [],
        skillTips: [],
        groups: []
      },
      handleSuccessstate: false,
      urls: configUrl.apiLink + "/uploadProjectContent/uploadProjectContent",
      // 工具arr
      toolsArr: [
        { code: "66", name: "电钻" },
        { code: "67", name: "板车" },
        { code: "68", name: "扳手" },
        { code: "69", name: "钳子" },
        { code: "other" }
      ],
      uploadAction: "",
      uploadfileDialog: false,
      orderNum: "",
      message: "该企业没有完成认证或账号已被冻结，无法发布需求到需求大厅",
      VerificationVisible: false, // 验证提示框
      workerGroupData: [], // 师傅群组
      contentListData: [], // 详细工作内容
      userInfo: "", // 用户信息
      companyId: "",
      radio: "",
      comworkerData: [],
      workerData: [], // 师傅数据
      tableLoading: false,
      projectManVisible: false, // 项目相关人弹框开关
      tagsArr:'',  //项目相关人
      workerGroupVisible: false, // 师傅群组弹框
      workerVisible: false,
      tags: [], // 日历
      workerGrouptags: [], // 师傅群组标签
      ownWokerTags: "", // 我的师傅标签
      ownWorker: [], // 获取选中的记录
      workerGrouptagsArr: "", // 师傅群组选中记录
      createVisible: false, // 弹框开关
      tableData: [], // 弹框表格数据
      needTools: [],
      workTypes: [],
      coutentId: 1,
      filePaths: [],
      uploadData: {},
      form: {
        type: []
      },
      uploadform: {
        files: null
      },
      uploadoption: {
        labelWidth: 120,
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "附件上传",
            loadText: "附件上传中，请稍等",
            prop: "files",
            type: "upload",
            limit: 1,
            span: 12,
            action: "/files/fileUpload"
          }
        ]
      },
      dynamicValidateForm: {
        projectName: "",
        stakeholderIds: "",
        userIds: "",
        groupIds: "",
        workTypes: [],
        needTools: [],
        isOvertime: false,
        isOen: false,
        startTime: "",
        domains: [],
        address: [
          {
            address: "", //工程地址
            position: "", //地图坐标X,Y
            contacts: "", //联系人
            contactPhone: "", //联系电话
            title: "", //标题
            category: "", //地点类型
            type: "", //类型
            adcode: "", //地区编码
            province: "", //省
            city: "", //市
            district: "", //区县
            houseNum: "" //门牌号
          }
        ]
      },
      //验证
      rules: {
        projectname : [{required: true, message: '请选择企业', trigger: 'blur' }],
        projectName: [
          { required: true, message: "需求名称不能为空", trigger: "blur" }
        ],
        address: [
          { required: true, message: "工程地址不能为空", trigger: "change" }
        ],
        startTime: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ],
        duration: [
          { required: true, message: "请输入工作时长", trigger: "blur" }
        ],
        needNum: [{ required: true, message: "请选择工种", trigger: "blur" }],
        name: [{ required: true, message: "请选择需求工具", trigger: "blur" }],
        tips: [{ required: true, message: "请输入工种内容", trigger: "blur" }],
        isOen: [{ required: true, message: "请输入发布渠道", trigger: "blur" }],
        houseNum1: [{ required: true, message: "门牌号", trigger: "blur" }],
        contacts1: [{ required: true, message: "联系人名称", trigger: "blur" }],
        contactPhone1: [
          { required: true, message: "联系人电话", trigger: "blur" }
        ]
      },

      tableoption: personnelget1,
      search: {
        companyId: this.companyId,
      },
      page: {
        pageSizes: [10, 20, 50, 100],
        currentPage: 1,
        total: 0,
        pageSize: 10
      },
      tableoptionqz: groupqz,
      tableoptionwork: {
        addBtn: false,
        selection: true,
        refreshBtn: false,
        columnBtn: true,
        editBtn: false,
        delBtn: false,
        menu: false,
        columnBtn: false,
        refreshBtn: false,
        columnBtn: false,
        header: true,
        headerMenu: false,
        page: true,
        border: true,
        searchLabelWidth: "80",
        search: {
          prop: "condition",
          label: "师傅信息",
          searchPlaceholder: "请输入关键字"
        },
        align: "center",
        menuAlign: "center",
        height: window.innerHeight - 230,
        index: false,
        column: [
          {
            label: "手机号码",
            prop: "phone",
            overHidden: true
          },
          {
            label: "姓名",
            prop: "name",
            overHidden: true
          },
          {
            label: "团队认证",
            prop: "isForeman",
            search: true,
            type: "select",
            dicData: [
              { label: "已认证", value: 1 },
              { label: "未认证", value: 0 }
            ],
            overHidden: true,
            formatter: function(row) {
              return row.isForeman == 1 ? "已认证" : "未认证";
            }
          },
          {
            label: "工种",
            prop: "workTypeIds",
            type: "select",
            dicData: {},
            props: {
              label: "name",
              value: "id"
            },
            search: true,
            overHidden: true
          },
          {
            label: "实名状态",
            prop: "workerState",
            formatter: function(row) {
              if (row.workerState == 1) {
                return "审核中";
              } else if (row.workerState == 2) {
                return "已认证";
              } else {
                return "未认证";
              }
            }
          },
          {
            label: "群组",
            prop: "groupNames",
            overHidden: true,
            type: "select",
            props: {
              label: "groupName",
              value: "id"
            },
            search: true
          }
        ]
      }
    };
  },
  filters: {
    dataFormat: function(dateStr) {
      return dateY(dateStr);
    },
    getBaseApiUrl: function(uri) {
      if (uri) {
        return apiLink(uri);
      } else {
        return "";
      }
    },
    getBaseImgUrl: function(uri) {
      console.log(uri);
      if (uri) {
        return getImgLink(uri);
      } else {
        return "";
      }
    }
  },
  components: { editContent, companylist },
  created() {
    this.getdicts();
    this.settime();
    this.Release();
    this.getProjectId();
    this.initDic();
    //设置一些默认信息
    // this.setuserinfo();
    // 企业是否认证
    this.uploadData = objKeySort({});
    this.tableoption.height = 400;
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  mounted() {},
  methods: {
    // 项目相关人多选
    handleSelectionChange(val) {
      this.tagsArr=val
    },
    // 项目相关人确定选择
    chooseTrue(){
      this.projectManVisible=false
      //已经选择了至少一个相关人
      if(this.tags.length>0)
        //选中的相关人和之前选中的相关人连接
        this.tags = this.tags.concat(this.tagsArr)
      else
        this.tags = this.tagsArr
      this.dynamicValidateForm.stakeholderIds =this.dataFilter(this.tagsArr)
    },

    // 项目相关人关闭标签
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
    },
    //项目相关人分页
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.getxmxgr()
     
    },
    //项目相关人分页
    currentChange(val) {
      this.page.currentPage = val
      this.getxmxgr()
    },
    //选择代发企业后的回调函数
    //代发企业的id和代发企业的名称
    refresh(companyId,name){
      this.companyId = companyId;
      this.projectname = name;
      this.totalStatus = false;
      //修改代发企业后，存储企业的相关信息
      this.getCompanyInfo(this.companyId)
    },
    //根据企业id获取企业信息的方法
    getCompanyInfo(companyId){
      getCompanyInfo(objKeySort({ 'companyId':companyId })).then(
        response => {
          if(response&&response.data&&response.data.data){
              this.companyInfo = response.data.data;
          }
        }
      )
    },
    //平台代发企业查询
    companyGroup(){
      // 子组件按钮的是否允许操作
      this.$refs.childcompany.setuserid();
    },
    setContent(content) {
      //debugger;
      if (content) {
        if (content.id) {
          for (let i = 0; i < this.dynamicValidateForm.domains.length; i++) {
            const domain = this.dynamicValidateForm.domains[i];
            if (domain.id === content.id) {
              this.dynamicValidateForm.domains[i] = content;
            }
          }
        } else {
          content.id = this.coutentId++;
          this.dynamicValidateForm.domains.push(content);
        }
      }
      console.log(content, this.dynamicValidateForm.domains);
    },
    addContent() {
      this.$refs.editContent.setData();
    },
    editContent(content) {
      this.$refs.editContent.setData(content);
    },
    //获取当前用户信息，获取用户名和手机号
    //在平台代发功能中，没有需要
    setuserinfo() {
      if(!this.userInfo)
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var opendata = this.userInfo
      this.dynamicValidateForm.address[0].contacts = opendata.name; //联系人
      this.dynamicValidateForm.address[0].contactPhone = opendata.phone;
    },
    initDic() {
      getDictList(objKeySort({ code: "worktype" })).then(response => {
        this.dic.workTypes = response.data.data.worktype;
        this.tableoptionwork.column[3].dicData = response.data.data.worktype;
      });
      getDictList(objKeySort({ code: "worker_skill" })).then(response => {
        this.dic.skillTips = response.data.data.worker_skill;
      });
      fetchList(objKeySort()).then(response => {
        this.dic.groups = response.data.data;
        this.tableoptionwork.column[5].dicData = response.data.data;
      });
    },
    //需求大厅
    //判断选择的企业是否能够发布任务到需求大厅
    xqdt() {
      if(this.checkIfCompanyChacked()){
           //根据企业id，获取企业的信息
          if(!this.companyInfo)
            this.getCompanyInfo(this.companyId)
          //判断企业的认证状态
          if (this.companyInfo.state != 2) {
            this.VerificationVisible = true;
            return;
          }
          if (this.dynamicValidateForm.isOen == false) {
            this.classA = true;
            this.dynamicValidateForm.isOen = true;
          } else {
            this.classA = false;
            this.dynamicValidateForm.isOen = false;
          }
      }
    },
    //获取项目id信息请求数据
    getProjectId() {
      var projectId = sessionStorage.getItem("projectId");
      if (projectId) {
        this.projectId = projectId;
        getProjectInfo(objKeySort({ projectId: projectId })).then(response => {
          this.dynamicValidateForm.projectName = response.data.data.projectName;
          this.dynamicValidateForm.address =
            response.data.data.projectAddresses;
          this.dynamicValidateForm.duration = response.data.data.duration;
          this.dynamicValidateForm.domains =
            response.data.data.workProjectContents;
          this.stakeholders =
            response.data.otherData.stakeholders != undefined
              ? response.data.otherData.stakeholders
              : [];
          this.handleSuccessstate =
            response.data.data.contentSource == 1 ? true : false;
          this.contentListData = response.data.data.workProjectContents;
        });
      }
    },
    //默认时间
    settime() {
      var myDate = new Date(); //获取系统当前时间
      var month =
        myDate.getMonth() + 1 > 10
          ? myDate.getMonth() + 1
          : "0" + (myDate.getMonth() + 1);
      var day =
        myDate.getDate() + 1 > 10
          ? myDate.getDate() + 1
          : "0" + (myDate.getDate() + 1);
      this.dynamicValidateForm.startTime =
        myDate.getFullYear() + "-" + month + "-" + day + " 09:00";
    },
    //删除多余地址
    deleteaddress(index) {
      this.dynamicValidateForm.address.splice(index, 1);
    },

    //删除多余任务内容
    deletetask(index) {
      this.dynamicValidateForm.domains.splice(index, 1);
    },

    //获取通用标签
    getdicts() {
      this.dynamicValidateForm.workTypes.length = 0;
      this.needTools.length = 0;
      getdicts(objKeySort()).then(response => {
        let datadic = response.data.data;
        //处理需求师傅
        for (let i = 0; i < datadic.worktype.length; i++) {
          this.dynamicValidateForm.workTypes.push({
            needNum: "",
            workTypeName: datadic.worktype[i].name,
            workTypeCode: datadic.worktype[i].id
          });
        }

        //处理需求工具
        for (let i = 0; i < datadic.needTools.length; i++) {
          this.needTools.push({
            name: datadic.needTools[i].name,
            code: datadic.needTools[i].id
          });
        }
      });
    },

    // 过滤出id
    dataFilter(dataItem) {
      var dataArr = [];
      for (var i of dataItem) {
        dataArr.push(i.id);
      }
      return dataArr.join(",");
    },
    //发布项目
    ReleaseInfo() {
      this.fadate = this.Preservation(0);
      if (this.fadate != false) {
        this.workerVisiblequdao = true;
      }
    },

    //取消操作
    Releasecancel() {
      sessionStorage.removeItem("projectId");
      this.$router.push("/project/list");
    },
    //发布项目
    ReleaseInfo() {
      this.fadate = this.Preservation(0);
      if (this.fadate != false) {
        this.workerVisiblequdao = true;
      }
    },

    //保存信息
    savebtn() {
      this.fadate = this.Preservation(-1);
      if (this.fadate != false) {
        this.workerVisiblequdao = true;
      }
    },

    //确定
    quertok() {
      insertOrUpdate(objKeySort(dealElement(this.fadate))).then(response => {
        sessionStorage.removeItem("projectId");
        this.$router.push("/project/list");
      });
    },

    //认证企业
    renzheng() {
      this.$router.push("/admin/legalize");
    },
    //数据处理
    Preservation(projectstate) {
      //判断数据信息
      if (!this.dynamicValidateForm.projectName) {
        this.$message("工程名称不能为空");
        return false;
      }
      //判断地址信息
      let dataAddress = this.dynamicValidateForm.address;
      for (var i = 0; i < dataAddress.length; i++) {
        if (
          !dataAddress[i].address ||
          !dataAddress[i].contacts ||
          !dataAddress[i].contactPhone ||
          !dataAddress[i].houseNum
        ) {
          if (!dataAddress[i].contactPhone) {
            if (dataAddress.length > 1) {
              this.$message("第" + (i + 1) + "个工程信息联系电话不能为空");
            } else {
              this.$message("联系电话不能为空");
            }
          }
          if (!dataAddress[i].contacts) {
            if (dataAddress.length > 1) {
              this.$message("第" + (i + 1) + "个工程信息联系人不能为空");
            } else {
              this.$message("联系人不能为空");
            }
          }
          if (!dataAddress[i].houseNum) {
            if (dataAddress.length > 1) {
              this.$message("第" + (i + 1) + "个工程信息门牌号不能为空");
            } else {
              this.$message("门牌号不能为空");
            }
          }
          if (!dataAddress[i].address) {
            if (dataAddress.length > 1) {
              this.$message("第" + (i + 1) + "个工程信息地址不能为空");
            } else {
              this.$message("地址不能为空");
            }
          }
          return false;
        }
      }

      //处理开工日期
      if (!this.dynamicValidateForm.startTime) {
        this.$message("开工时间不能为空");
        return false;
      }

      //处理工作时长
      if (!this.dynamicValidateForm.duration) {
        this.$message("开工时长不能为空");
        return false;
      }

      //处理工作任务
      let taskinfo = new Array();
      for (let i = 0; i < this.dynamicValidateForm.domains.length; i++) {
        taskinfo.push({
          tips: this.dynamicValidateForm.domains[i].tips,
          imgPaths: this.dynamicValidateForm.domains[i].imgPaths,
          voicePaths: this.dynamicValidateForm.domains[i].voicePaths
        });
      }

      //处理需求工具
      let needTool = new Array();
      for (let i = 0; i < this.dynamicValidateForm.needTools.length; i++) {
        for (let j = 0; j < this.needTools.length; j++) {
          if (this.dynamicValidateForm.needTools[i] == this.needTools[j].name) {
            needTool.push({
              code: this.needTools[j].code,
              name: this.needTools[j].name
            });
          }
        }
      }

      //判断是否有其他工具
      if (this.dynamicValidateForm.tool) {
        needTool.push({ code: "other", name: this.dynamicValidateForm.tool });
      }
      const fileList = this.$refs.uploadAppendix.uploadFiles;
      if (fileList && fileList.length > 0) {
        fileList.forEach(f => {
          if ((f.response && f.response.data.filePath) || f.url) {
            this.filePaths.push({
              name: f.response.data.fileName,
              url: (f.response ? f.response.data.filePath : f.url).replace(
                new RegExp(getImgLink(""), "g"),
                ""
              )
            });
          }
        });
      }

      //处理工种数据
      let work = new Array();
      for (let i = 0; i < this.dynamicValidateForm.workTypes.length; i++) {
        if (Number(this.dynamicValidateForm.workTypes[i].needNum) > 0) {
          work.push({
            workTypeCode:
              '"' + this.dynamicValidateForm.workTypes[i].workTypeCode + '"',
            workTypeName: this.dynamicValidateForm.workTypes[i].workTypeName,
            needNum: this.dynamicValidateForm.workTypes[i].needNum
          });
        }
      }

      //判断工种
      if (work.length == 0) {
        this.$message("需求工种不能为空");
        return false;
      }

      // //判断需求工具不能为空
      //  if(needTool.length==0){
      //     this.$message('需求工具不能为空');
      //     return false
      // }

      //判断工种内容不能为空
      if (this.handleSuccessstate != true) {
        for (let i = 0; i < taskinfo.length; i++) {
          if (taskinfo[i].tips == "") {
            this.$message("工作内容不能为空");
            return false;
          }
        }
      }

      //相关人
      var stakeholderIds = new Array()
      for (var i = 0; i < this.tags.length; i++) {
        stakeholderIds.push(this.tags[i].id)
      }
      var workers = [];
      if (this.ownWorker.length > 0) {
        for (var i = 0; i < this.ownWorker.length; i++) {
          console.log(this.ownWorker);
        }
      }

      if (
        this.dynamicValidateForm.isOen == false &&
        !this.dynamicValidateForm.groupIds &&
        !this.dynamicValidateForm.userIds
      ) {
        this.$message("发布渠道不能为空");
        return false;
      }

      var data = {
        projectId: this.projectId,
        projectName: this.dynamicValidateForm.projectName,
        addresses: JSON.stringify(this.dynamicValidateForm.address),
        duration: this.dynamicValidateForm.duration,
        isOvertime: this.dynamicValidateForm.isOvertime ? 1 : 0,
        needTools: JSON.stringify(needTool),
        stakeholderIds: this.dynamicValidateForm.stakeholderIds,
        startTime: this.dynamicValidateForm.startTime,
        workProjectContent: JSON.stringify(taskinfo),
        workTypes: JSON.stringify(work),
        isOen: this.dynamicValidateForm.isOen == false ? 0 : 1,
        state: projectstate,
        groupIds: this.dynamicValidateForm.groupIds,
        userIds: this.dynamicValidateForm.userIds,
        contentSource: this.handleSuccessstate == true ? 1 : 2,
        filePaths: JSON.stringify(this.filePaths),
        stakeholderIds: stakeholderIds ? stakeholderIds.join(",") : null
      };
      return data;
    },
    submitUpload() {
      if (this.contentListData && this.contentListData.length > 0) {
        this.$confirm("已经导入过工作内容, 本次导入将会覆盖上次导入工作内容，是否重新导入?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$refs.uploadContent.submit();
          })
          .catch(() => {
            
          });
      }else{
          this.$refs.uploadContent.submit();
      }

      
    },

    //上传成功或失败
    handleChange(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
    },

    // 获取projectId
    Release() {
      getOrderCode(objKeySort({})).then(response => {
        this.projectId = response.data.data;
      });
    },

    // 我的师傅多选
    workSelectionChange(val) {
      this.ownWokerTags = val;
    },
    // 我的师傅确定选择
    workerTrue() {
      this.workerVisible = false;
      this.ownWorker = this.ownWokerTags;
      this.dynamicValidateForm.userIds = this.dataFilter(this.ownWorker);
    },
    // 师傅群组确定选择
    workerGroupchange(val) {
      this.workerGrouptagsArr = val;
    },
    workerGroupTrue() {
      this.workerGroupVisible = false;
      this.workerGrouptags = this.workerGrouptagsArr;
      this.dynamicValidateForm.groupIds = this.dataFilter(this.workerGrouptags);
    },
    // 师傅群组关闭标签
    workerGroupClose(tag) {
      this.workerGrouptags.splice(this.workerGrouptags.indexOf(tag), 1);
    },
    workerGroupworker(data) {
      this.ownWorker = data;
    },
    // 师傅关闭标签
    workerClose(tag) {
      this.ownWorker.splice(this.ownWorker.indexOf(tag), 1);
    },
    getSerialNumber(index) {
      return index + 1;
    },

    // 师傅群组弹框
    workerGroup() {
      console.log(this.workerGrouptags);
      getGroupList(objKeySort({companyId : this.companyId})).then(response => {
        this.workerGroupData = response.data.data;
      });
      this.workerGroupVisible = true;
    },
    workerBtn() {
      //判断是否选择了代发企业
      if(this.checkIfCompanyChacked()){
        this.searchgr.companyId = this.companyId
        getWorkerList(objKeySort(this.searchgr)).then(response => {
          this.workerData = response.data.data;
          this.workerData.forEach(data => {
          data.workTypeIds = this.formatterWorkType(data.workTypeIds);
        });
      });
      this.workerVisible = true;
      }
    },
    //刷新列表操作
    formatterWorkType(workTypeIds) {
      var workTypeNames = "";
      if (workTypeIds && workTypeIds.length > 0) {
        workTypeIds.split(",").forEach(workerTypeId => {
          if (this.dic.workTypes) {
            this.dic.workTypes.forEach(workerType => {
              if (workerType.id == workerTypeId) {
                workTypeNames = workTypeNames + workerType.name + ",";
              }
            });
          } else {
            return workTypeIds;
          }
        });
      }
      if (workTypeNames.length > 0) {
        workTypeNames = workTypeNames.substring(0, workTypeNames.length - 1);
      }
      return workTypeNames;
    },
    // 导入
    importBtn() {
      //获取token
      this.uploaddata.Token = sessionStorage.getItem("access_token");
      this.uploaddata.projectId = this.projectId;
      console.log(this.uploaddata);
      this.uploadfileDialog = true;
    },

    //上传成功
    handleAvatarSuccess(response, file, fileList) {
      this.handleSuccessstate = true;
      this.uploadfileDialog = false;
      this.contentListData = response.data;
      this.$refs.uploadContent.clearFiles();
      console.log('handleAvatarSuccess', file, fileList)
    },

    //取消上传
    close() {
      this.uploadfileDialog = false;
      this.uploadform.files = undefined;
    },
    //上传后的方法
    uploadAfter(res, done, loading) {
      console.log('loading', loading)
      done();
      this.uploadform.files.push({
        label: "反馈图片",
        value: res.data.data.filePath
      });
      for (var i = 0; i < this.uploadform.files.length; i++) {
        if (this.uploadform.files[i].value === undefined)
          this.uploadform.files.splice(i, 1);
      }
      this.uploadform.files.push(res.data.data.filePath);
    },
    // 详细工作内容
    contentList() {
      this.createVisible = true;
    },

    // 新增项目相关负责人
    addProjectPeople() {
      if(this.checkIfCompanyChacked()){
          this.getxmxgr();
          this.projectManVisible = true;
      }
    },
    //检查是否选择了代发企业
    checkIfCompanyChacked(){
      //判断是否选择了项目相关人
      if(!this.userInfo)
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      //平台管理员账号
      if(this.userInfo.userType==1){
        //判断是否选择代发企业
        if(!this.projectname){
          this.$message.error("请先选择一个代发企业")
          return false
        }else{
          return true;
        }
      }else{
        //非平台管理员不可访问该功能
        this.$message.error("当前用户非平台管理员")
        return false;
      }
    },

    addDomain() {
      this.dynamicValidateForm.domains.push({
        tips: "",
        key: Date.now()
      });
    },
    address() {
      if(!this.userInfo)
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var opendata = this.userInfo;
      this.dynamicValidateForm.address.push({
        address: "", //工程地址
        position: "", //地图坐标X,Y
        contacts: opendata.name, //联系人
        contactPhone: opendata.phone, //联系电话
        title: "", //标题
        category: "", //地点类型
        type: "", //类型
        adcode: "", //地区编码
        province: "", //省
        city: "", //市
        district: "", //区县
        houseNum: "" //门牌号
      });
    },
    //获取项目相关人
    getxmxgr() {
      //这句代码需要判断
      this.comworkerData = [];
      this.search.companyId = this.companyId;
      this.search.current = this.page.currentPage;
      this.search.size = this.page.pageSize;
      getWorkerInfo(objKeySort(this.search)).then(response => {
        this.page.total = response.data.data.total;
        response.data.data.rows.forEach(comworker => {
          //查询出的用户列表中是否包含已经选中的用户
          let flag = true;
          if (this.tags.length > 0) {
            this.tags.forEach(tag => {
              if (tag.id == comworker.id) {
                flag = false;
              }
            });
          }
          if (flag) {
            this.comworkerData.push(comworker);
          }
        });
      });
    },

    //清空
    searchReset() {
      this.page.currentPage = 1;
      this.page.pageSize = 20;
      this.getxmxgr();
    },
    //搜索数据
    searchChange(params) {
      if (!params.name) {
        params.name = "";
      }
      this.search.conditions = params.conditions;
      this.getxmxgr();
    },

    //搜索师傅信息
    searchChangegr(params) {
      this.searchgr = {
        condition: params.condition ? params.condition : "",
        groupId: params.groupNames,
        isForeman: params.isForeman,
        workTypeId: params.workTypeIds
      };
      getWorkerList(objKeySort(dealElement(this.searchgr))).then(response => {
        this.workerData = response.data.data;
        this.workerData.forEach(data => {
          data.workTypeIds = this.formatterWorkType(data.workTypeIds);
        });
      });
      console.log(this.searchgr);
    },
    selectionChange(list) {
      this.tagsArr = list;
    },
    //图片路径处理
    getimgpath(data) {
      return getImgLink(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.avue-main ::v-deep .container {
  width: 900px;
}
.form_layout_items {
  display: flex;
}
.select_option {
  position: absolute;
  z-index: 22;
  width: 150px !important;
  right: 0;
  top: 0;
}
.el-table ::v-deep .el-table__row:nth-child(even) {
  background-color: #f6f9ff !important;
}
.form_layout_item {
  width: 50%;
  border: 1px solid #fff;
  height: 80px;
}
.files {
  text-align: center;
}
.upinfo {
  text-align: left;
  color: rgb(33, 150, 243);
}
.tag {
  margin-right: 15px;
}
.avue-crud .avue-crud__menu {
  display: none;
}
.class-a {
  background: #fff;
  color: #3a8ee6;
  border: 1px solid #3a8ee6;
  float: left;
}
.class-b {
  background: #3a8ee6;
  color: #fff;
  float: left;
}
.fbqd {
  margin-bottom: 15px;
}
.gzstyle {
  width: 115px;
}

.textOverflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

